module.exports = __webpack_public_path__ + "img/history-2019.481da5ad.webp";